export function safeGet<T>(fn: () => T): T | null {
  try {
    const result = fn();
    return result === undefined ? null : result;
  } catch {
    return null;
  }
}

export async function safeAsyncGet<T>(fn: () => Promise<T>): Promise<T | null> {
  try {
    const result = await fn();
    return result === undefined ? null : result;
  } catch {
    return null;
  }
}

export async function sha256Hex(data: string): Promise<string> {
  const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(data));
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
